import { alpha, styled } from '@mui/material/styles';
import React, { useState } from 'react';
import { AppBar, IconButton, Toolbar } from '@mui/material';
import { Typography } from '@mui/material';
import DrawerCustom from './DrawerCustom'
import { useNavigate } from "react-router-dom";
import useAuth from '../../hooks/useAuth';
import { Menu, Close, ArrowBack } from '@mui/icons-material';

const RootStyle = styled(AppBar)(({ theme }) => ({
	boxShadow: 'none',
	backdropFilter: 'blur(6px)',
	WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
	backgroundColor: alpha(theme.palette.background.default, 0.72),
}));

/**
 * @param {String} color (opcional), primary é default, primary|white|transparent
 * @param {String} title (opcional), título a ser exibido
 * @param {bool} menu (opcional), default é false, se for true chama o componente Drawer
 * @param {function} goBack 
 */
export default function AppBarCustom(props) {
	const { logout } = useAuth();
	const [drawer, setDrawer] = useState(false);
	let navigate = useNavigate()

	const back = () => {
		navigate(-1);
	}

	const toggleDrawer = async (rota) => {
		setDrawer(!drawer)
		if (rota && rota !== '') {
			if (rota !== '/') {
				navigate(rota);
			} else {
				try {
					await logout();
					navigate('/', { replace: true })
				} catch (error) {
					console.log(error);
					await logout();
					navigate('/', { replace: true })
				}
			}
		}
	}

	const toolbar = () => {
		//Reorganizado dessa forma para impedir o erro Firefox onClick not working in button
		if (Boolean(props.menu) === true) {
			return (
				<Toolbar>
					<IconButton sx={{ '&.MuiIconButton-root': { outline: 'none' } }} edge="start" aria-label="menu" onClick={() => toggleDrawer()}>
						<Menu sx={{ color: "grey.900" }} />
					</IconButton>
					<Typography variant="h4" sx={{ color: "grey.900" }}>
						{props.title}
					</Typography>
				</Toolbar>
			)
		} else if (props.close) {
			return (
				<Toolbar>
					<IconButton sx={{ '&.MuiIconButton-root': { outline: 'none' } }} edge="start" aria-label="menu" onClick={() => back()}>
						<Close sx={{ color: "grey.900" }} />
					</IconButton>
					<Typography variant="h4" sx={{ color: "grey.900" }}>
						{props.title}
					</Typography>
				</Toolbar>
			)
		} else {
			return (
				<Toolbar>
					<IconButton sx={{ '&.MuiIconButton-root': { outline: 'none' } }} edge="start" aria-label="menu" onClick={() => back()}>
						<ArrowBack sx={{ color: "grey.900" }} />
					</IconButton>
					<Typography variant="h4" sx={{ color: "grey.900" }}>
						{props.title}
					</Typography>
				</Toolbar>
			)
		}
	}

	return (
		<div>
			<DrawerCustom open={drawer} onClose={(r) => toggleDrawer(r)} />
			<RootStyle>
				{toolbar()}
			</RootStyle>
		</div>
	)
}